// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_DocumentConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/document_config
 *
 * Returns document configuration for the tenant or a specific franchise.
 * Response shape depends on whether franquia_id is provided:
 *   - franquia_id present: per-franchise document_types/required/default + country.
 *   - franquia_id absent:  the full country_map, keyed by ISO 3166-1 alpha-2 code.
 */
import type { Clientes_DocumentConfigCountryRow } from './Clientes_DocumentConfigCountryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_DocumentConfigResponseDados {
document_types?: string[]
document_required?: boolean
default_document_type?: string
country?: string
country_name?: string
country_map?: Record<string, Clientes_DocumentConfigCountryRow>
}

export type Clientes_DocumentConfigResponse = ApiResponse<Clientes_DocumentConfigResponseDados>;

registerResponseContract('Clientes_DocumentConfigResponse', {
  document_types:        { type: 'array',   required: false },
  document_required:     { type: 'boolean', required: false },
  default_document_type: { type: 'string',  required: false },
  country:               { type: 'string',  required: false },
  country_name:          { type: 'string',  required: false },
  country_map:           { type: 'object',  required: false },
})
